import React from 'react';
import PropTypes from 'prop-types';
import Grid from "@mui/material/Grid";
import {FormattedMessage} from "react-intl";
import HeaderContainer from "../../../../components/List/components/HeaderContainer";
import TableRowHead from "../../../../components/WMS/List/TableRowHead";
import {TableHead} from "@mui/material";
import TableCellHead from "../../../../components/WMS/List/TableCellHead";

function Header() {

    return (
        <TableHead>
            <TableRowHead isDesktop>
                {[
                    <FormattedMessage id={'wms.missionModel.header.name'} />,
                    <FormattedMessage id={'wms.missionModel.header.status'} />,
                    <FormattedMessage id={'wms.missionModel.header.createdAt'} />,
                    <FormattedMessage id={'list.header.actions'} />,
                ].map((column) => (
                    <TableCellHead key={column} variant={'head'}>
                        {column}
                    </TableCellHead>
                ))}
            </TableRowHead>
        </TableHead>
    )
}

export default Header;